// import { CanActivateFn } from '@angular/router';
import { Injectable } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthSession } from 'aws-amplify/auth';
import { SignUpInput, SignUpOutput, signUp } from 'aws-amplify/auth';
import { AuthUser } from 'aws-amplify/auth';

import {
  fetchAuthSession,
  getCurrentUser
} from 'aws-amplify/auth';

export const authGuard : CanActivateFn = async (route, state) => {
  const router = new Router();
  console.log('authGuard:route' , route);
  try {
    const {
      username,
      signInDetails
    } = await getCurrentUser();
    console.log('authGuard:username' , username);
    if (!username) {
      // router.navigate(['/dashboard']);
      router.navigate(['/login']);
      return false;
    }
    return true;
  } catch (e) {
    console.error(e);
    router.navigate(['/login']);
    return false;
  }
  // const {
  //   username,
  //   signInDetails
  // } = await getCurrentUser();
  // if (!username) {
  //   router.navigate(['/login']);
  //   return false;
  // }
  // return true;
};

